(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.vantStyle = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isHidden = isHidden;
  function isHidden(el) {
    var style = window.getComputedStyle(el);
    var hidden = style.display === 'none';
    // offsetParent returns null in the following situations:
    // 1. The element or its parent element has the display property set to none.
    // 2. The element has the position property set to fixed
    var parentHidden = el.offsetParent === null && style.position !== 'fixed';
    return hidden || parentHidden;
  }
});